import React, { useEffect, useState } from 'react'
import { PRODUCTS } from '../../Products'
import { Link } from 'react-router-dom'
import { ProductDetails } from './ProductDetails'
import './RelatedProducts.css'

const RelatedProducts = (props) => {
    const {id, category, brand} = props
    const {pid, setPid} = useState(id)

    useEffect(() => {
    },[])
    let pbrand= []
    let pcategory=[]
    let related_prod_id=[]
    console.log(category)
    PRODUCTS.map((prodProp)=> {
        if (prodProp.category == category && prodProp.id !=id ) {
            related_prod_id.push(prodProp.id)
            pcategory.push(prodProp.category)
            pbrand.push(prodProp.brand)
            console.log(related_prod_id.length)
        }})
    PRODUCTS.map((prodProp)=> {
        if(related_prod_id.length <=3){
            if (prodProp.brand==brand && prodProp.id !=id ){
                related_prod_id.push(prodProp.id)
            }
        }
        else{
            if (related_prod_id.length <2){
                related_prod_id.push(prodProp.id)
            }
            
        }
        return (<></>)
    })
    const [scroll, setScroll] = useState(false)
    const changeColor =()=>{
        window.scrollY >=90? setScroll(true): setScroll(false)
    }
    window.addEventListener("scroll", changeColor)

  return (
    <div id='relatedProducts'>
        {PRODUCTS.map((prodProp2) => {
            try{
            for(let temp_id=0; temp_id<3 ; temp_id++){
                if (prodProp2.id===related_prod_id[temp_id]){
                    return (<div id='prodcard'>

                    <Link to={`/ProductDetails/${prodProp2.id}`} className='m-auto' element={<ProductDetails data={props.data}/>} >
                        <div id='prodImg'><img src={prodProp2.productImg} alt=''/>
                        </div>
                        <p>{prodProp2.productName}</p>
                        <p> {'\u20B9'} {prodProp2.price} </p>
                        <br/>
                        <hr id='lowerborder'/>
                        <br/>
                        </Link>
                    </div>)
                }
            {/* <img src></img>   */}
            } return (<></>)
        }
        finally{        }
        })}
        {/* {related_prod_id+','} {pcategory} {pbrand} RelatedProducts */}
        
    </div>
  
    )
}

export default RelatedProducts